import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IGroup } from "./getGroupList";

// 그룹 수정 요청 인터페이스
export interface IUpdateGroupRequest {
  name?: string;
  status?: string;
  user_ids?: string[];
}

/**
 * 그룹 정보 수정 API 함수
 * @param id 수정할 그룹의 ID
 * @param data 수정할 데이터
 * @returns API 응답
 */
export const apiUpdateGroup = async (id: string, data: IUpdateGroupRequest) => {
  const response = await apiPatch<IGroup>(`/groups/${id}`, data);
  return response;
};

/**
 * 그룹 정보 수정 React Query 훅
 * @param id 수정할 그룹의 ID
 * @returns 뮤테이션 객체
 */
export const useUpdateGroup = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IUpdateGroupRequest) => apiUpdateGroup(id, data),
    onSuccess: () => {
      // 전체 그룹 목록과 특정 그룹 데이터 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.detail(id) });
    },
  });
};

export default useUpdateGroup;
